import { ActionsCreators, connectToJava } from "@tipico/java-react-connector";
import PinPad, { PinPadProps } from "../../components/PinPad/PinPad";

const actionsCreators: ActionsCreators<{
    onNewPin: (newPin: string) => void;
}> = {
    onNewPin: {
        creator: (newPin: string) => newPin,
        name: "ChangePinRequest"
    }
};

export default connectToJava({
    actionsCreators,
    options: { useBehaviorSubjects: false },
    state: {
        ChangePinState: undefined
    },
    stateMapper: ({
        ChangePinState: validationResponse
    }): Pick<
        PinPadProps,
        "needsPreValidation" | "validationResult" | "validationTimestamp"
    > => ({
        needsPreValidation: true,
        validationResult: validationResponse,
        validationTimestamp: Date.now()
    })
})(PinPad);
